










































































































import { mixins } from "vue-class-component";
import WeMixin from "@/components/weMixin";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";
import {
  Form,
  Calendar,
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  List,
  Button,
  Cell,
  Picker,
  CellGroup,
  SwipeCell,
  ActionSheet,
  Dialog,
  Popup,
  DatetimePicker,
  Image,
  Collapse,
  CollapseItem,
  Divider,
  DropdownMenu,
  DropdownItem,
} from "vant";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";
import { Toast, Panel } from "vant";
import { Icon } from "vant";
import { Loading } from "vant";
import { PullRefresh, Grid, GridItem, Card, Tabbar, TabbarItem } from "vant";
import Axios, { AxiosResponse } from "axios";
import { RegisterInfo } from "../user/UserApi";

@Component({
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Picker.name]: Picker,
    [List.name]: List,
    [Panel.name]: Panel,
    [Calendar.name]: Calendar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Loading.name]: Loading,
    [Dialog.name]: Loading,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [SwipeCell.name]: SwipeCell,
    [ActionSheet.name]: ActionSheet,
    [Image.name]: Image,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
})
export default class RightsHomeInit extends mixins(WeMixin, Jssdk) {
  private active: number = 0;
  private activeColor: string = process.env.VUE_APP_COLOR as string;

  private toMyUserUrl: string = "";

  protected created() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.accounttype === "0") {
        this.toMyUserUrl = "/main/user/userInfo";
      } else if (res.data.accounttype === "1") {
        this.toMyUserUrl = "/main/user/userInfoMerchant";
      }
    });
  }
}
